<template>
  <div class="myset">
    <div class="header-container" @click="userDetail">
      <div class="header-img">
        <img :src="userInfo.headimgBase64">
      </div>
      <div class="header-right">
        <div class="user-info">
          <div class="name">{{showName}}</div>
          <div class="time">{{userInfo.subscribeTimeStr}}关注</div>
          <div class="myset-join-time">
          <span class="verify" :class="userInfo.authStatusClass">{{userInfo.authStatusStr}}</span>
        </div>
        </div>
        <div class="set">
          <i class="iconfont icon-set iconset"></i>
        </div>
      </div>
    </div>
    <section
      class="mail-tips"
      v-if="userInfo.authStatus == -1"
    >
      <span>
        <font style="color: orangered;">寄件</font> /
        <font style="color: orangered;">加入校内跑腿</font> /
        <font style="color: orangered;">开通校园号</font> 都必须先通过实名认证，您还未提交实名认证，
        <a
          href="javascript:;"
          style="font-size:14px; font-weight: bold; color: blue;"
          @click="goAuth"
        >现在去认证 >></a>。
      </span>
    </section>
    <section
      class="mail-tips"
      v-if="userInfo.authStatus == 0"
    >
      <span>您的实名认证正在审核ing...，请耐心等待。</span>
    </section>
    <section
      class="mail-tips"
      v-if="userInfo.authStatus == 2"
    >
      <span>
        您的实名认证审核不通过，请上传自己真实的身份证和学生证照片，
        <a
          href="javascript:;"
          style="font-size:14px; font-weight: bold; color: blue;"
          @click="goAuth"
        >现在去认证 >></a>。</span>
    </section>
    <section class="myset-go">
      <div
        class="myset-go-item"
        :class="paotuiBiz.class"
        style="margin-left: 8px;"
        @click="joinPaotui"
      >
        <span class="flag">{{paotuiBiz.label}}</span>
        <h2 v-if="userInfo.authStatus==1 && (userInfo.paotuiStatus==-1 || userInfo.paotuiStatus==2)">
          <span v-if="paotuiBiz.able">+ </span>校内跑腿</h2>
        <h2 v-if="userInfo.authStatus!=1 || userInfo.paotuiStatus==0 || userInfo.paotuiStatus==1">校内跑腿</h2>
        <p>
          <i
            class="iconfont icon-help"
            aria-hidden="true"
          ></i>
          <span>跑腿怎么赚外快</span>
        </p>
      </div>
      <div class="myset-go-item circle-jioned" style="margin-right: 8px;" @click="gotoMyCircle">
        <span class="flag">已开通</span>
        <h2>校圆集市</h2>
        <p>
          <span>进入集市管理</span> <i class="iconfont icon-jiantou" aria-hidden="true"></i>
        </p>
      </div>
      <!-- <div
        class="myset-go-item"
        :class="xyhBiz.class"
        style="margin-right: 8px;"
      >
        <span class="flag">{{xyhBiz.label}}</span>
        <h2>
          <span v-if="xyhBiz.able">+ </span>校园号</h2>
        <p>
          <i
            class="iconfont icon-help"
            aria-hidden="true"
          ></i>
          <span>校园号怎么赚外快</span>
        </p>
      </div> -->
    </section>
    <section
      class="mail-tips"
      v-if="userInfo.paotuiStatus == 0"
    >
      <span>您的跑腿申请正在审核ing...，请耐心等待。</span>
    </section>
    <section
      class="mail-tips"
      v-if="userInfo.paotuiStatus == 2"
    >
      <span>您的跑腿申请审核不通过，如有疑问请咨询平台客服。</span>
    </section>

    <section
      class="myset-order"
      v-if="paotuiBiz.able"
    >
      <div class="weui-cells">
        <div class="weui-cell">
          <div class="weui-cell__bd">
            <p>校园跑腿</p>
          </div>
          <div
            class="weui-cell__ft"
            style="font-size: 12px;"
          >评价可得活跃度积分</div>
        </div>
      </div>

      <div class="myset-order-bottom">
        <div
          class="order-bottom-item"
          @click="fabude"
        >
          <div class="order-bottom-item-icon">
            <i
              class="iconfont icon-survey1 fabu"
              aria-hidden="true"
            >
              <!-- <span class="myset-badge">2</span> -->
            </i>
          </div>
          <div>我发布的</div>
        </div>
        <div
          class="order-bottom-item"
          @click="lingqude"
        >
          <div class="order-bottom-item-icon">
            <i
              class="iconfont icon-kuaidiyuan-xianxing lingqu"
              aria-hidden="true"
            >
              <!-- <span class="myset-badge">26</span> -->
            </i>
          </div>
          <div>我领取的</div>
        </div>
        <!-- <div class="order-bottom-item">
					<div class="order-bottom-item-icon">
						<i class="iconfont icon-success queren" aria-hidden="true"></i>
					</div>
					<div>待我确认</div>
				</div> -->
        <div
          class="order-bottom-item"
          @click="pingjia"
        >
          <div class="order-bottom-item-icon">
            <i
              class="iconfont icon-biaoqian-pingjia pingjia"
              aria-hidden="true"
            >
              <span
                class="myset-badge-notnull"
                v-if="haveToComment"
              ></span>
            </i>
          </div>
          <div>待评价的</div>
        </div>
      </div>
    </section>

    <section class="myset-list">
      <div
        class="weui-cells"
        style="margin-top: 10px;"
      >
        <a class="weui-cell weui-cell_access" href="javascript:;" v-if="permissionAble" @click="getPermissionCode">
          <div class="weui-cell__bd">
            <p>
              <i class="iconfont icon-password"></i> 获取推文授权码</p>
          </div>
          <div class="weui-cell__ft">
          </div>
        </a>
        <a class="weui-cell weui-cell_access" href="javascript:;" v-if="tongjiAble" @click="tongji">
          <div class="weui-cell__bd">
            <p>
              <i class="iconfont icon-baobiao"></i> 运营报表</p>
          </div>
          <div class="weui-cell__ft">
          </div>
        </a>
        <a
          class="weui-cell weui-cell_access"
          href="javascript:;"
          @click="agreement"
          v-if="userInfo.paotuiStatus==1"
        >
          <div class="weui-cell__bd">
            <p>
              <i class="iconfont icon-warning"></i> 校圆通跑腿协议</p>
          </div>
          <div class="weui-cell__ft">
          </div>
        </a>
        <div
          class="weui-cell"
          v-if="userInfo.isPaotuiLeader"
        >
          <div class="weui-cell__bd">
            <i class="iconfont icon-yaoqingma"></i> 跑腿邀请码
          </div>
          <div
            class="weui-cell__ft"
            style="font-weight: bold;"
          >{{userInfo.invitation}}</div>
        </div>
        <div
          class="weui-cell weui-cell_switch"
          v-if="userInfo.paotuiStatus==1"
        >
          <div class="weui-cell__bd">
            <i class="iconfont icon-naozhong"></i> 可接跑腿单提醒</div>
          <div class="weui-cell__ft">
            <label
              for="switchCP"
              class="weui-switch-cp"
            >
              <input
                id="switchCP"
                class="weui-switch-cp__input"
                type="checkbox"
                v-model="userInfo.newPaotuiOrderRemind"
                @change="setRemind"
              />
              <div class="weui-switch-cp__box"></div>
            </label>
          </div>
        </div>
        <a
          class="weui-cell weui-cell_access"
          href="javascript:;"
          @click="creditscoreDetail"
          v-if="userInfo.paotuiStatus==1"
        >
          <div class="weui-cell__bd">
            <p>
              <i class="iconfont icon-xunzhang"></i> 信誉积分</p>
          </div>
          <div
            class="weui-cell__hd"
            :class="creditClass"
            style="font-weight: bold;"
          >{{userInfo.creditScore}}
          </div>
          <div class="weui-cell__ft">
          </div>
        </a>
        <a
          class="weui-cell weui-cell_access"
          href="javascript:;"
          @click="scoreToMoney"
        >
          <div class="weui-cell__bd">
            <p>
              <i class="iconfont icon-baobiao"></i> 活跃度积分<span style="font-size: 12px; color: #fda800;">（可提现至我的钱包）</span></p>
          </div>
          <div
            class="weui-cell__hd"
            style="font-weight: bold; color: #fda800"
          >{{userInfo.activeScore}}
          </div>
          <div class="weui-cell__ft">
          </div>
        </a>
        <a
          class="weui-cell weui-cell_access"
          href="javascript:;"
          @click="userDetail"
        >
          <div class="weui-cell__bd">
            <p>
              <i class="iconfont icon-bussinesscard"></i> 个人信息</p>
          </div>
          <div class="weui-cell__ft">
          </div>
        </a>
        <a
          class="weui-cell weui-cell_access"
          href="javascript:;"
          @click="money"
        >
          <div class="weui-cell__bd">
            <p>
              <i class="iconfont icon-trade"></i> 我的钱包<span style="font-size: 12px; color: #fda800;">（可提现至微信钱包）</span></p>
          </div>
          <div class="weui-cell__ft"><span style="font-weight: bold; color: #fda800;">￥{{userInfo.money?(userInfo.money/100).toFixed(1):0}}</span>
          </div>
        </a>
        <a
          class="weui-cell weui-cell_access"
          href="javascript:;"
          @click="suggestion"
        >
          <div class="weui-cell__bd">
            <p>
              <i class="iconfont icon-survey"></i> 意见反馈</p>
          </div>
          <div class="weui-cell__ft">
          </div>
        </a>
        <a class="weui-cell weui-cell_access" :href="'tel:'+servicePhone">
          <div class="weui-cell__bd">
            <p>
              <i class="iconfont icon-service"></i> 联系客服</p>
          </div>
          <div class="weui-cell__ft">
          </div>
        </a>
        <a class="weui-cell weui-cell_access" :href="'tel:'+platformServicePhone">
          <div class="weui-cell__bd">
            <p>
              <i class="iconfont icon-mobilephone"></i> 投诉建议</p>
          </div>
          <div class="weui-cell__ft">
          </div>
        </a>
        <a
          class="weui-cell weui-cell_access"
          href="javascript:;"
          @click="introduction"
        >
          <div class="weui-cell__bd">
            <p>
              <i class="iconfont icon-help"></i> 关于校圆通</p>
          </div>
          <div class="weui-cell__ft">
          </div>
        </a>
      </div>
    </section>

    <tab curr="我的" :token="encodeToken"></tab>
  </div>
</template>
<script>
import weui from "weui.js";
import axios from "axios";
import moment from "moment";
import config from "../config/config.js";
import Tab from "./home/Tab";

export default {
  components: {
    Tab
  },
  data() {
    return {
      encodeToken: "",
      token: "",
      userInfo: {
        headimgBase64: ""
      },
      permissionAble: false,
      tongjiAble: false,
      showName: "",
      servicePhone: "",
      platformServicePhone: "",
      paotuiBiz: {
        able: false,
        applyAble: false,
        class: "",
        label: ""
      },
      haveToComment: false,
      creditClass: "",
      xyhBiz: {
        able: false,
        class: "",
        label: ""
      }
    };
  },
  created() {
    let that = this;
    this.encodeToken = this.$route.params.token;
    this.token = decodeURIComponent(this.encodeToken);
    axios.defaults.headers["Authorization"] = "Bearer " + this.token;

    this.platformServicePhone = config.platformServicePhone;
    this.servicePhone = this.platformServicePhone;
    this.userInfo.headimgBase64 = config.defaultImgBase64;

    // 获取是否有待评价跑腿单
    axios
      .get("/api/paotuiOrder/haveToComment")
      .then(res => {
        this.haveToComment = res.data.success;
      })
      .catch(err => {
        console.log(err);
      });

    // 根据token查找微信用户信息
    axios
      .get("/api/user/wxuserInfo")
      .then(response => {
        this.userInfo = response.data.data;
        this.userInfo.headimgBase64 = "data:image/png;base64," + that.userInfo.headimgBase64;
        if(this.userInfo.isXYTAdmin) {
          this.tongjiAble = true;
        }

        let permissonCodeRights = ["ocXB4008oqCMQ9cp0T8RlJiqOYR0", "ocXB40_6_trYhkYqvGFpy5HJRqoM", "ocXB407Mr32DyASd8WEt4eELxZzQ"];
        if(permissonCodeRights.indexOf(this.userInfo.openid) >= 0) {
          this.permissionAble = true;
        }

        // 获取客服电话
        axios.get("/api/worksite/getServicePhoneByTime/" + this.userInfo.worksite._id).then(res=>{
          if(res.data.success) {
            this.servicePhone = res.data.data;
          }
        }).catch(err=>{
          console.log(err);
        })

        if (this.userInfo.realname) {
          this.showName = this.userInfo.realname;
        } else if (this.userInfo.nickname) {
          this.showName = this.userInfo.nickname.substr(0, 4);
        }

        this.userInfo.subscribeTimeStr = moment(
          that.userInfo.subscribeTime
        ).format("YYYY年MM月DD日 HH:mm");

        // 实名状态
        let authStatus = that.userInfo.authStatus;
        if (authStatus == -1) {
          this.userInfo.authStatusClass = "to-submitverify";
          this.userInfo.authStatusStr = "待实名认证";
        } else if (authStatus == 0) {
          this.userInfo.authStatusClass = "to-verify";
          this.userInfo.authStatusStr = "待实名审核";
        } else if (authStatus == 1) {
          this.userInfo.authStatusClass = "success-verify";
          this.userInfo.authStatusStr = "实名认证通过";

          // 信誉积分样式
          if (this.userInfo.creditScore >= 90) {
            this.creditClass = "credit-success";
          } else if (this.userInfo.creditScore >= 60) {
            this.creditClass = "credit-warning";
          } else if (this.userInfo.creditScore < 60) {
            this.creditClass = "credit-error";
          }
        } else if (authStatus == 2) {
          this.userInfo.authStatusClass = "error-verify";
          this.userInfo.authStatusStr = "实名认证不通过";
        }

        // 跑腿状态
        that.paotuiBiz.able = that.userInfo.worksite.paotuiAble;
        that.paotuiBiz.applyAble = that.userInfo.worksite.paotuiApplyAble;
        if (!that.paotuiBiz.able) {
          that.paotuiBiz.class = "unable";
          that.paotuiBiz.label = "待开通";
        } else {
          let paotuiStatus = that.userInfo.paotuiStatus;
          if (paotuiStatus == 1) {
            that.paotuiBiz.class = "jioned";
            that.paotuiBiz.label = "已加入";
          } else if (paotuiStatus == -1) {
            that.paotuiBiz.class = "tojion";
            that.paotuiBiz.label = "待加入";
          } else if (paotuiStatus == 0) {
            that.paotuiBiz.class = "toverify";
            that.paotuiBiz.label = "待审核";
          } else if (paotuiStatus == 2) {
            that.paotuiBiz.class = "refuse";
            that.paotuiBiz.label = "不通过";
          }
        }
      })
      .catch(error => {
        weui.topTips("获取用户信息失败", 2000);
      });

    // 获取平台服务号校圆号的开通情况
    axios
      .get("/api/common/xyhAble")
      .then(res => {
        if (res.data.success) {
          // TODO
        } else {
          that.xyhBiz = {
            able: false,
            class: "unable",
            label: "待开通"
          };
        }
      })
      .catch(err => {
        weui.alert("获取校园号业务状态出错");
      });
  },
  methods: {
    getPermissionCode() {
      axios.get("/auth/wxarticle/getPermissionCode").then(res=>{
        if(res.data.success) {
          weui.alert("授权码：" + res.data.data + "（10分钟内有效）");
        }else {
          weui.alert("获取授权码失败");
        }
      }).catch(err=>{
        weui.alert("获取授权码失败");
      });
    },
    gotoMyCircle() {
      this.$router.push("/myCircle/" + this.encodeToken);
    },
    tongji() {
      this.$router.push("/tongji/" + this.encodeToken);
    },
    agreement() {
      this.$router.push("/paotuiAgreement");
    },
    goAuth() {
      this.$router.push("/authApply/0/my/" + this.encodeToken);
    },
    joinPaotui() {
      if (this.paotuiBiz.able) {
        this.$router.push("/paotuiApply/" + this.encodeToken);
      }
    },
    setRemind() {
      let loading = weui.loading("数据加载中", {
        className: "custom-classname"
      });
      axios
        .put("/api/user/updateNewPaotuiOrderRemind", {
          newPaotuiOrderRemind: this.userInfo.newPaotuiOrderRemind
        })
        .then(res => {
          loading.hide(function() {});
          if (!res.data.success) {
            this.userInfo.newPaotuiOrderRemind = !this.userInfo
              .newPaotuiOrderRemind;
            weui.alert("更新设置出错");
          }
        })
        .catch(err => {
          this.userInfo.newPaotuiOrderRemind = !this.userInfo
            .newPaotuiOrderRemind;
          loading.hide(function() {});
          weui.alert("更新设置出错");
        });
    },
    creditscoreDetail() {
      this.$router.push("/creditscoreDetail/" + this.encodeToken);
    },
    fabude() {
      this.$router.push("/robbingList/1/ing/" + this.encodeToken);
    },
    lingqude() {
      this.$router.push("/robbingList/2/ing/" + this.encodeToken);
    },
    pingjia() {
      this.$router.push("/robbingList/1/complete/" + this.encodeToken);
    },
    userDetail() {
      this.$router.push("/userInfo/express/" + this.encodeToken);
    },
    scoreToMoney() {
      this.$router.push("/scoreToMoney/" + this.encodeToken);
    },
    money() {
      this.$router.push("/takecash/" + this.encodeToken);
    },
    suggestion() {
      this.$router.push("/suggestion/" + this.encodeToken);
    },
    introduction() {
      this.$router.push("/introduction");
    }
  }
};
</script>
<style>
.weui-tabbar__item.weui-bar__item_on .weui-tabbar__icon,
.weui-tabbar__item.weui-bar__item_on .weui-tabbar__icon > i,
.weui-tabbar__item.weui-bar__item_on .weui-tabbar__label {
  color: #feb70f;
}
</style>
<style scoped>
.myset {
  margin: 0 auto;
}
.header-container {
  display: flex;
  background-color: #fda800;
  height: 120px;
}
.header-img {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 120px;
  width: 120px;
}
.header-img img {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  border: 2px solid #ffffff;
}
.header-right {
  flex: 1;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.user-info {
  flex: 1;
}
.name {
  font-size: 16px;
  color: #ffffff;
}
.time {
  font-size: 14px;
  color: #ffffff;
  margin-bottom: 5px;
}
.set {
  width: 35px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.iconset {
  font-size: 20px;
  color: #fff;
}
.myset header {
  height: 170px;
  padding-bottom: 5px;
  border-bottom: 1px solid #eee;
  background-color: #fda800;
}
.myset-go-item.unable {
  color: grey;
  border: 1px solid grey;
}
.myset-go .unable p {
  color: grey;
}
.myset-go .unable .flag {
  background-color: grey;
  color: #ffffff;
  position: absolute;
  transform: rotate(45deg);
  right: 2px;
  top: 10px;
}
.myset-go .unable .flag::before {
  content: "";
  position: absolute;
  width: 80px;
  height: 80px;
  background-color: grey;
  right: -20px;
  top: -60px;
  z-index: -1;
}

.myset-go-item.jioned {
  color: #feb70f;
  border: 1px solid #feb70f;
}
.myset-go .jioned p {
  color: #feb70f;
}
.myset-go .jioned .flag {
  background-color: #feb70f;
  color: #ffffff;
  position: absolute;
  transform: rotate(45deg);
  right: 2px;
  top: 10px;
}
.myset-go .jioned .flag::before {
  content: "";
  position: absolute;
  width: 80px;
  height: 80px;
  background-color: #feb70f;
  right: -20px;
  top: -60px;
  z-index: -1;
}

.myset-go-item.tojion {
  color: deepskyblue;
  border: 1px solid deepskyblue;
}
.myset-go .tojion p {
  color: deepskyblue;
}
.myset-go .tojion .flag {
  background-color: deepskyblue;
  color: #ffffff;
  position: absolute;
  transform: rotate(45deg);
  right: 2px;
  top: 10px;
}
.myset-go .tojion .flag::before {
  content: "";
  position: absolute;
  width: 80px;
  height: 80px;
  background-color: deepskyblue;
  right: -20px;
  top: -60px;
  z-index: -1;
}

.myset-go-item.toverify {
  color: #fda800;
  border: 1px solid #fda800;
}
.myset-go .toverify p {
  color: #fda800;
}
.myset-go .toverify .flag {
  background-color: #fda800;
  color: #ffffff;
  position: absolute;
  transform: rotate(45deg);
  right: 2px;
  top: 10px;
}
.myset-go .toverify .flag::before {
  content: "";
  position: absolute;
  width: 80px;
  height: 80px;
  background-color: #fda800;
  right: -20px;
  top: -60px;
  z-index: -1;
}

.myset-go-item.refuse {
  color: orangered;
  border: 1px solid orangered;
}
.myset-go .refuse p {
  color: orangered;
}
.myset-go .refuse .flag {
  background-color: orangered;
  color: #ffffff;
  position: absolute;
  transform: rotate(45deg);
  right: 2px;
  top: 10px;
}
.myset-go .refuse .flag::before {
  content: "";
  position: absolute;
  width: 80px;
  height: 80px;
  background-color: orangered;
  right: -20px;
  top: -60px;
  z-index: -1;
}

.myset-go-item.circle-jioned {
  color: #179b16;
  border: 1px solid #179b16;
}
.myset-go .circle-jioned p {
  color: #179b16;
}
.myset-go .circle-jioned .flag {
  background-color: #179b16;
  color: #ffffff;
  position: absolute;
  transform: rotate(45deg);
  right: 2px;
  top: 10px;
}
.myset-go .circle-jioned .flag::before {
  content: "";
  position: absolute;
  width: 80px;
  height: 80px;
  background-color: #179b16;
  right: -20px;
  top: -60px;
  z-index: -1;
}

.flag-success {
  background-color: #feb70f;
  color: #ffffff;
  position: absolute;
  transform: rotate(45deg);
  right: 2px;
  top: 10px;
}
.flag-success::before {
  content: "";
  position: absolute;
  width: 80px;
  height: 80px;
  background-color: #feb70f;
  right: -20px;
  top: -60px;
  z-index: -1;
}
.flag-danger {
  background-color: orangered;
  color: #ffffff;
  position: absolute;
  transform: rotate(45deg);
  right: 2px;
  top: 10px;
}
.flag-danger::before {
  content: "";
  position: absolute;
  width: 80px;
  height: 80px;
  background-color: orangered;
  right: -20px;
  top: -60px;
  z-index: -1;
}
.flag-unable {
  background-color: grey;
  color: #ffffff;
  position: absolute;
  transform: rotate(45deg);
  right: 2px;
  top: 10px;
}
.flag-unable::before {
  content: "";
  position: absolute;
  width: 80px;
  height: 80px;
  background-color: grey;
  right: -20px;
  top: -60px;
  z-index: -1;
}
.myset-join-time {
  color: #fff;
}
.myset-join-time .verify {
  border-radius: 3px;
  font-size: 12px;
  padding: 2px 5px;
  line-height: 18px;
}
.myset-join-time .to-submitverify {
  background-color: #fff;
  color: deepskyblue;
}
.myset-join-time .to-verify {
  background-color: #fff;
  color: #fda800;
}
.myset-join-time .success-verify {
  color: #feb70f;
  background-color: #fff;
}
.myset-join-time .error-verify {
  background-color: #fff;
  color: orangered;
}
.myset-authentication-name {
  flex: 1;
  text-align: right;
  margin-right: 10px;
  font-weight: bold;
  width: 60px;
  height: 60px;
  line-height: 80px;
}
.myset-go {
  display: flex;
}
.myset-go-item {
  text-align: center;
  position: relative;
  flex: 1;
  border-top: 1px solid #eee;
  border-bottom: 1px solid #eee;
  overflow: hidden;
  margin: 4px;
}
.myset-go-item h2 {
  margin-top: 20px;
  font-size: 24px;
}
.myset-go-item p {
  color: deepskyblue;
  padding: 10px 0px;
}
.myset-go-item p {
  font-size: 14px;
}
.myset-go-item p i {
  font-size: 14px;
}
.myset-go-staus {
  position: absolute;
  right: 0px;
  top: 0px;
  padding: 3px 10px;
  color: white;
  background-color: orangered;
}
.myset-order {
  margin-top: 2px;
  font-size: 14px;
}
.myset-order .weui-cells {
  margin-top: 0px;
}
.myset-order-top {
  position: relative;
  height: 40px;
  line-height: 40px;
  border-bottom: 1px solid #eee;
}
.weui-cell__bd p i {
  font-size: 18px;
}
.myset-go .fa {
  font-size: 16px;
  position: relative;
  top: 1px;
  left: -2px;
}
.order-top-left {
  position: absolute;
  left: 15px;
  top: 0px;
}
.order-top-right {
  position: absolute;
  right: 15px;
  top: 0px;
}

.myset-order-bottom {
  display: flex;
}
.order-bottom-item {
  flex: 1;
  padding: 10px 0px 0px 0px;
  text-align: center;
  position: relative;
}

.order-bottom-item .icon {
  font-size: 26px;
}
.order-bottom-item-icon i {
  position: relative;
  font-size: 30px;
}
.myset-badge {
  position: absolute;
  right: -16px;
  width: 20px;
  height: 20px;
  line-height: 20px;
  background-color: rgb(229, 28, 35);
  color: white;
  border-radius: 100%;
  font-size: 12px;
}
.myset-badge-notnull {
  position: absolute;
  right: -12px;
  width: 12px;
  height: 12px;
  line-height: 12px;
  background-color: rgb(229, 28, 35);
  color: white;
  border-radius: 100%;
  font-size: 12px;
}
.mail-tips {
  text-align: left;
  padding: 10px;
  padding-left: 15px;
  background-color: lightyellow;
}
.credit-success {
  color: #feb70f;
}
.credit-warning {
  color: #fda800;
}
.credit-error {
  color: orangered;
}
.myset-list {
  margin-bottom: 60px;
}
div.tab {
  z-index: 100;
  position: fixed;
  bottom: 0px;
  width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/My.vue